import {
  ChangeDetectionStrategy,
  Component,
  NgZone,
  OnInit,
} from '@angular/core';
import { LanguageManagerService } from './_services/languagemanager.service';
import { Subscription } from 'rxjs';
import { HttpEventService } from './_services/http-event-service.service';

@Component({
  selector: 'DCO-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class AppComponent {
  title = 'DClaims - Merchant Portal';
  appVersion = '3.1.1.60529';
  loadedStartup = false;
  fallbackError = false;

  private languagesDownloaded$!: Subscription;
  private connectionError$!: Subscription;
  private connectionErrorInterceptor$!: Subscription;

  constructor(
    private _translationService: LanguageManagerService,
    private ngZone: NgZone,
    private httpEventService: HttpEventService,
  ) {
    //console.log(this.title, this.appVersion);
    this.languagesDownloaded$ =
      this._translationService.languagesDownloaded$.subscribe((languages) => {
        // cuando termina de cargar los idiomas mostramos el desplegable
        // console.log("En zona?", NgZone.isInAngularZone(), languages);
        if (languages.length > 0) {
          this.loadedStartup = true;
        }
      });
    this.connectionError$ = this._translationService.connectionError$.subscribe(
      (error) => {
        this.fallbackError = true;
        this.loadedStartup = true;
      },
    );
    this.httpEventService.error$.subscribe((err) => {
      this.fallbackError = true;
      this.loadedStartup = true;
    });
  }
}
